import { Checkbox } from "@nabble/ui";

interface SuiteAccessFieldsProps {
  suiteAdmin: boolean;
  onChange: (suiteAdmin: boolean) => void;
}

/** The "Suite administrator" checkbox: access to the whole suite, apart from the roles in each organization. */
export function SuiteAccessFields({ suiteAdmin, onChange }: SuiteAccessFieldsProps): React.JSX.Element {
  return (
    <Checkbox
      label="Suite administrator"
      description="Opens the Admin Center: every organization, person, module and policy."
      checked={suiteAdmin}
      onChange={(e) => onChange(e.target.checked)}
    />
  );
}
